import React from 'react';

const LoadingScreen: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gradient-to-br from-white to-gray-50">
      <div className="text-center">
        <div className="mb-6 flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 animate-ping">
              <img
                src="/salespad logo.svg"
                alt="SalesPad"
                className="w-24 h-24 opacity-20"
              />
            </div>
            <div className="relative animate-pulse">
              <img
                src="/salespad logo.svg"
                alt="SalesPad"
                className="w-24 h-24"
              />
            </div>
          </div>
        </div>
        <div className="text-gray-800 text-xl font-extrabold font-display animate-pulse">
          Loading your sales data…
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
